/**
 * The app-level `ConsentBanner` (ADR-075) owns the settings-variant card, but the
 * surfaces that re-open it — the marketing footer's "Privacy settings" link and
 * the cookieless notice's opt-out link — live elsewhere in the tree. Rather than
 * thread shared React state across those distant siblings, they coordinate
 * through a window event: any surface asks, the banner (which listens) opens.
 *
 * Re-open is strictly user-initiated (a click), so moving focus to the card is
 * never a mount-time focus-steal (EPT-144).
 */
export const OPEN_CONSENT_SETTINGS_EVENT = 'consent:open-settings'

/** Ask the app-level `ConsentBanner` to open its settings variant. */
export function openConsentSettings(): void {
	if (typeof window === 'undefined') return
	window.dispatchEvent(new Event(OPEN_CONSENT_SETTINGS_EVENT))
}
